import { OWManager } from "../../OW.Remoting/Remoting/OWManager";
import { ISignatureReferenceUriGenerator } from "./ISignatureReferenceUriGenerator";

export class RemotingDocumentReferenceUriGenerator implements ISignatureReferenceUriGenerator {
    private _fileName: string | undefined;

    constructor(fileName?: string) {
        this._fileName = fileName;
    }

    public async getReferenceUri(): Promise<string> {
        return `tescosw://${await OWManager.getServerId()}/dataService/${this._fileName ? this._fileName : "sameDocument"}`; //`
    }
}
